export function nextPartCode (parts) {
  const used = new Set(parts.map(part => String(part.key || '').trim()))
  let number = 1
  while (used.has('PART_' + String(number).padStart(3, '0'))) number++
  return 'PART_' + String(number).padStart(3, '0')
}

export function partCapacity (parts, points, key, excludedId = '') {
  const part = parts.find(value => value.key === key)
  const raw = part?.total, limit = raw !== '' && raw != null && Number.isSafeInteger(Number(raw)) && Number(raw) >= 0 ? Number(raw) : null
  const used = points.filter(point => point.key === key && (!excludedId || point.id !== excludedId)).length
  return { part, limit, used, remaining: limit == null ? 0 : Math.max(0, limit - used) }
}

export function partCapacityError (parts, points, key, added = 1, excludedId = '') {
  const { part, limit, used } = partCapacity(parts, points, key, excludedId)
  if (!part) return '请选择有效的部件类型'
  if (limit == null) return '请先为“' + part.name + '”配置有效的非负整数辖区总量'
  return used + added > limit ? '“' + part.name + '”辖区总量为 ' + limit + '，已配置 ' + used + '，本次需添加 ' + added + '，不能超过辖区总量' : ''
}
